import { api } from './client';
import type { Problem, MoveResult, UserStats, LeaderboardEntry, DailyResponse, HintResponse, SolutionNode } from '../types';

export async function verifyAuth(initDataRaw: string) {
  const { data } = await api.post('/auth/verify', {}, {
    headers: { Authorization: `tma ${initDataRaw}` },
  });
  return data as { token: string; user: { id: number; username: string; first_name: string } };
}

export async function getProblems(params?: { difficulty?: number; category?: string; limit?: number; offset?: number }) {
  const { data } = await api.get('/problems', { params });
  return data as { problems: Problem[]; total: number };
}

export async function getRandomProblem(difficulty?: number) {
  const { data } = await api.get('/problems/random', { params: { difficulty } });
  return data as Problem;
}

export async function getDailyProblems() {
  const { data } = await api.get('/problems/daily');
  return data as DailyResponse;
}

export async function getProblem(id: string) {
  const { data } = await api.get(`/problems/${encodeURIComponent(id)}`);
  return data as Problem;
}

export async function solveProblem(id: string, coord: string, timeMs: number, sessionId?: string) {
  const { data } = await api.post(`/problems/${encodeURIComponent(id)}/solve`, {
    coord,
    time_ms: timeMs,
    session_id: sessionId,
  });
  return data as MoveResult;
}

export async function getSolution(id: string) {
  const { data } = await api.get(`/problems/${encodeURIComponent(id)}/solution`);
  return data as { solutions: SolutionNode[] };
}

export async function getHint(id: string, level: number = 1) {
  const { data } = await api.get(`/problems/${encodeURIComponent(id)}/hint`, { params: { level } });
  return data as HintResponse;
}

export async function getMyStats() {
  const { data } = await api.get('/stats/me');
  return data as UserStats;
}

export async function getLeaderboard(period: string = 'alltime', limit: number = 50) {
  const { data } = await api.get('/leaderboard', { params: { period, limit } });
  return data as { entries: LeaderboardEntry[]; my_rank: number };
}
